<template>
  <div class="hidden" data-qa="qa-translation-probe">
    {{ i18n(props.definition) }}
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '../composables/useI18n'
import type { I18nDefinition } from '../types'

const i18n = useI18n()

const props = defineProps<{
  definition: I18nDefinition
}>()
</script>
